export default __webpack_public_path__ + "static/media/video_homepage.4079376a.mp4";